import { useSelector, useDispatch } from "react-redux";
import {
    setPortfoliosData,
    setCampaignsData,
    setAdgroupsData,
    setKeywordsData,
    setPlacementsData,
    setProductsData,
    setProductAnalyticsData,
    setProductMappingData,
} from "@features/gridDataSlice";
import {
    updatePoCheckedNode,
    updateAdCheckedNode,
    updateCaCheckedNode,
    updatePdCheckedNode,
} from "@features/filtersSlice";
import {
    updateKeywordsSelectionData,
    updateNegativeKeywordsSelectionData,
    updateOverviewKeywordsSelectionData,
    updateProductsSelectionData,
} from "@features/selectedDataSlice";
import { useContext } from "react";
import { mainContext } from "@ts/constants";
import { IMainContext, ParentModule } from "@ts/common-types";
import { getActiveModule } from "@/ts/utils";

const useClearGridData = () => {
    const {
        setAlertsData,
        setActiveRulesData,
        setIsCheckboxSelected,
        setProductMappingGridLoading,
    } = useContext<IMainContext>(mainContext);
    const { activeParentModule } = getActiveModule();
    const dispatch = useDispatch();
    const clearData = () => {
        if (activeParentModule !== ParentModule.PERFORMANCE_OVERVIEW) {
            setAlertsData([]);
            setActiveRulesData([]);
            dispatch(setKeywordsData([]));
            dispatch(setPlacementsData([]));
            dispatch(setPortfoliosData([]));
            dispatch(setCampaignsData([]));
            dispatch(setAdgroupsData([]));
            dispatch(setProductsData([]));
            dispatch(updatePoCheckedNode([]));
            dispatch(updateAdCheckedNode([]));
            dispatch(updateCaCheckedNode([]));
            dispatch(updatePdCheckedNode([]));
            dispatch(updateOverviewKeywordsSelectionData([]));
        }

        if (activeParentModule !== ParentModule.KEYWORD_ANALYTICS) {
            dispatch(updateKeywordsSelectionData([]));
        }

        if (activeParentModule !== ParentModule.PRODUCT_ANALYTICS) {
            dispatch(setProductAnalyticsData([]));
            dispatch(updateProductsSelectionData([]));
        }

        if (activeParentModule !== ParentModule.NEGATIVE_KEYWORDS) {
            dispatch(updateNegativeKeywordsSelectionData([]));
        }

        if (activeParentModule !== ParentModule.SETTINGS) {
            dispatch(setProductMappingData([]));
            setProductMappingGridLoading(true);
        }
        setIsCheckboxSelected(false);
    };
    return clearData;
};

export default useClearGridData;
